<div class="min-h-[calc(100vh-80px)] flex items-center justify-center p-4 bg-gray-50">
  <div class="bg-white rounded-2xl p-8 sm:p-10 shadow-xl max-w-lg w-full text-center border border-gray-100">
    <!-- Success Icon -->
    <div class="mb-6">
      <div class="inline-flex p-4 bg-green-100 rounded-full animate-pulse">
        <svg class="w-20 h-20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" fill="url(#successGradient)" />
          <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <defs>
            <linearGradient id="successGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#10B981;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#059669;stop-opacity:1" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>

    <!-- Success Content -->
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">Excellent!</h1>
      <p class="text-gray-600 font-medium">{{ successMessage }}</p>
    </div>

    <!-- Feedback Section -->
    <ng-container *ngIf="!feedbackSubmitted">
      <div class="border-t border-gray-100 pt-6">
        <div class="mb-6">
          <h3 class="text-xl font-semibold text-gray-900 mb-2">Share Your Experience</h3>
          <p class="text-sm text-gray-600">How would you rate your experience?</p>
        </div>

        <div class="mb-6">
          <div class="flex justify-center gap-2">
            <div 
              *ngFor="let star of [1,2,3,4,5]" 
              class="cursor-pointer transition-transform hover:scale-110"
              (click)="setRating(star)" 
              (mouseover)="setHoverRating(star)" 
              (mouseleave)="setHoverRating(0)">
              <svg class="w-7 h-7 transition-all duration-200" 
                   [class]="star <= (hoverRating || selectedRating) ? 'text-yellow-400' : 'text-gray-300'"
                   [class.scale-110]="star <= selectedRating || (star <= hoverRating && hoverRating > selectedRating)"
                   width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
                      fill="currentColor" stroke="none"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="mb-6 text-left">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Tell us more about your experience (Optional)
          </label>
          <textarea 
            class="w-full p-3 border border-gray-300 rounded-lg text-sm resize-none transition-colors focus:outline-none focus:border-blue-500 focus:ring-3 focus:ring-blue-100 placeholder-gray-400"
            [(ngModel)]="feedbackMessage"
            placeholder="What did you like? What could we improve?"
            rows="3"
            maxlength="300">
          </textarea>
          <div class="text-right text-xs text-gray-400 mt-1">{{ feedbackMessage.length }}/300</div>
        </div>

        <div class="text-center">
          <eh-button 
            type="primary" 
            [disabled]="selectedRating === 0"
            (btnClick)="submitFeedback()">
            <span>Submit Feedback</span>
          </eh-button>
        </div>
      </div>
    </ng-container>
    
    <!-- Final Message -->
    <div *ngIf="feedbackSubmitted" class="text-center animate-fade-in">
      <div class="mb-4">
        <svg class="w-12 h-12 mx-auto text-red-500" viewBox="0 0 24 24" fill="none">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="currentColor"/>
        </svg>
      </div>
      <h3 class="text-2xl font-semibold text-gray-900 mb-2">Thank You!</h3>
      <p class="text-gray-600 mb-4">Your feedback helps us improve our platform.</p>
      <p class="text-sm text-gray-400 italic">You can close this window now.</p>
    </div>
  </div>
<!-- </div> -->
